import React from 'react';
import { createAppSwitcherBffAvailableProductsProvider } from './app-switcher-bff-available-products-provider';
var _ref = createAppSwitcherBffAvailableProductsProvider(),
  fetchAppSwitcherBffAvailableProducts = _ref.fetchMethod,
  DefaultBffDataProviderComponent = _ref.ProviderComponent;
export var AvailableProductsProvider = function AvailableProductsProvider(_ref2) {
  var cloudId = _ref2.cloudId,
    product = _ref2.product,
    children = _ref2.children;
  return /*#__PURE__*/React.createElement(DefaultBffDataProviderComponent, {
    cloudId: cloudId,
    product: product
  }, children);
};
export var prefetchAvailableProducts = fetchAppSwitcherBffAvailableProducts;
export var resetAvailableProducts = function resetAvailableProducts() {
  return fetchAppSwitcherBffAvailableProducts.reset();
};